import type { CertificatePriceLimit } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'

/**
 * The most a certificate can cost and still be covered by the add-on's yearly
 * credit, already formatted and localized by the backend.
 *
 * Resolved server-side by this experiment's `getCertsAddOnPriceLimit` — an
 * empty string means the fetch returned nothing, so callers must drop the
 * clause that would have carried it rather than render a gap.
 */
export const useCertsAddOnPriceLimit = (): string => {
  const { certsAddOnPriceLimit } = useStaticData<{
    certsAddOnPriceLimit: CertificatePriceLimit | null
  }>()

  return certsAddOnPriceLimit?.displayPrice ?? ''
}
